import { Button, Space } from "antd";
import { times } from "lodash";
import React, { useState } from "react";
import { Document  as PDFDocument, Page } from "react-pdf/dist/esm/entry.webpack5";
import { Icon } from "@iconify/react";

interface Props {
  title?: string;
  subTitle?: string;
  show: boolean;
  setShow: (value: boolean) => void;
  url: string;
  scale?: number;
}

export const PDFView = ({ url, scale }: Props) => {
  const [numPages, setNumPages] = useState<number>(0);
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  return (
      <PDFDocument
        file={url}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={console.error}
        renderMode="canvas"
      >
        <Space
          size="small"
          align="start"
          style={{
            width: "100%",
            justifyContent: "center",
          }}
          direction="vertical"
        >
          {times(numPages, (page) => (
            <div
              style={{
                // border: "1px solid rgba(0,0,0,.2)",
                // padding: 10,
              }}
            >
              <Page
                pageNumber={page + 1}
                width={window.innerWidth - window.innerWidth * 0.3}
                scale={scale || 0.9}
              />
            </div>
          ))}
        </Space>
      </PDFDocument>
  );
};
